// extracted by mini-css-extract-plugin
module.exports = {"row":"Row_row__1wrVO","label":"Row_label__2kFk6","content":"Row_content__3uyCn"};